export default {
    computed: {
        userSessionToken() {
            return app.auth.token;
        },
        userSessionUrlToken() {
            return app.auth.urlToken;
        },
        l_defaultListRecordIdNameInput() {
            return this.defaultListRecordIdNameInput ? this.defaultListRecordIdNameInput : `${this.dbTableName}_id`;
        },
        l_defaultReadRecordIdNameInput() {
            return this.defaultReadRecordIdNameInput ? this.defaultReadRecordIdNameInput : `${this.dbTableName}_id`;
        },
        l_defaultUpdateRecordIdNameInput() {
            return this.defaultUpdateRecordIdNameInput ? this.defaultUpdateRecordIdNameInput : `${this.dbTableName}_id`;
        },
        l_defaultDeleteRecordIdNameInput() {
            return this.defaultDeleteRecordIdNameInput ? this.defaultDeleteRecordIdNameInput : `${this.dbTableName}_id`;
        },
        loading: {
            get: () => {
                return app.store.state.ks_app.global_data.loading;
            },
            set: (value) => {
                app.store.commit('ks_app/global_data/setLoading', value);
            }
        }
    },
    methods: {
        async callToList(filters = {}, page = 0, pageSize = 99999, orderBy = null) {
            try {
                //the list uses the skeleton
                //this.loading = true;
                let data = await app.sdk[this.dbName][`${this.dbTableName}_list`](
                    this.userSessionToken,
                    {
                        ...filters,
                        'row_count_skip': page * pageSize,
                        'row_count_take': pageSize,
                        'order_by': orderBy
                    },
                    true,
                    [],
                    null,
                    `${this.id}-${this._uid}`
                );
                this.loading = false;
                return data;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        },
        async callToCreate(record = {}, files = []) {
            try {
                this.loading = true;
                let token = files && files.length > 0 ?  this.userSessionUrlToken : this.userSessionToken;
                let data = await app.sdk[this.dbName][`${this.dbTableName}_create`](
                    token,
                    record,
                    false,
                    files,
                    null,
                    `${this.id}-${this._uid}`
                );
                this.loading = false;
                this.$emit('onCallToCreate', data);
                return data;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        },
        async callToRead(campaignId = null, recordId = null, filters = {}) {
            try {
                let requestParameters = filters;
                requestParameters[`${this.l_defaultReadRecordIdNameInput}`] = recordId;
                requestParameters[`${this.defaultCampaignIdName}`] = campaignId;
                this.loading = true;
                let data = await app.sdk[this.dbName][`${this.dbTableName}_read`](
                    this.userSessionToken,
                    requestParameters,
                    true,
                    [],
                    null,
                    `${this.id}-${this._uid}`
                );
                this.loading = false;
                return data;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        },
        async callToUpdate(record = {}, files = [], writeNulls = 0) {
            try {
                this.loading = true;
                let token = files && files.length > 0 ?  this.userSessionUrlToken : this.userSessionToken;
                let data = await app.sdk[this.dbName][`${this.dbTableName}_update`](
                    token,
                    {
                        ...record,
                        'write_nulls': writeNulls
                    },
                    false,
                    files,
                    null,
                    `${this.id}-${this._uid}`
                );
                this.loading = false;
                return data;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        },
        async callToDelete(campaignId = null, recordId = null) {
            try {
                let requestParameters = {};
                requestParameters[`${this.l_defaultDeleteRecordIdNameInput}`] = recordId;
                requestParameters[`${this.defaultCampaignIdName}`] = campaignId;
                this.loading = true;
                let data = await app.sdk[this.dbName][`${this.dbTableName}_delete`](
                    this.userSessionToken,
                    requestParameters,
                    true,
                    [],
                    null,
                    `${this.id}-${this._uid}`
                );
                this.loading = false;
                return data;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        }
    }
}
